export default {
  metadata: {
    version: '1.0.0',
    id: 'carousel-1.0.0',
    name: 'JDSCarousel',
    description:
      'Carousel is a component for cycling through a series of content slides that can be composed of a combination of images, text and cards.',
    usage:
      'Carousels are used to promote multiple items of conent within a single area on a screen.'
  },
  hierarchy: {
    container: [
      {
        'slider-container': ['carousel-slot']
      },
      {
        'control-container': [
          {
            'left-container': [
              {
                'progress-container': [
                  'jds_spinner',
                  'prefix-jds_action_button'
                ]
              },
              {
                'prefix-container': ['title-jds-text', 'subtitle-jds-text']
              }
            ]
          },
          'jds_carousel_pagination',
          {
            'right-container': [
              'back-jds_action_button',
              'next-jds_action_button'
            ]
          }
        ]
      }
    ]
  },
  base: {
    container: {
      'flex-direction': '{c_0}',
      'justify-content': '{c_1}',
      'align-items': '{c_2}',
      gap: '{c_3}',
      width: '{c_4}'
    },
    'slider-container': {
      width: '{c_5}'
    },
    'control-container': {
      'flex-direction': '{c_6}',
      'justify-content': '{c_7}',
      'align-items': '{c_8}',
      gap: '{c_9}',
      width: '{c_10}'
    },
    'left-container': {
      flex: 1,
      'max-width': '{c_11}',
      'flex-direction': '{c_12}',
      'justify-content': '{c_13}',
      'align-items': '{c_14}',
      gap: '{c_15}',
      'padding-top': '{c_16}',
      'padding-bottom': '{c_17}',
      show: true
    },
    'progress-container': {
      hidden: true,
      'flex-direction': '{c_21}',
      'justify-content': '{c_22}',
      'align-items': '{c_23}'
    },
    'prefix-jds_action_button': {
      icon: 'ic_play',
      size: 'medium',
      kind: 'secondary',
      'z-index': 0
    },
    jds_spinner: {
      hidden: true,
      kind: 'normal',
      'z-index': 0
    },
    'prefix-container': {
      hidden: true,
      'flex-direction': '{c_18}',
      'justify-content': '{c_19}',
      'align-items': '{c_20}'
    },
    'right-container': {
      flex: 1,
      'max-width': '{c_27}',
      'flex-direction': '{c_28}',
      'justify-content': '{c_29}',
      'align-items': '{c_30}',
      gap: '{c_31}',
      'padding-top': '{c_32}',
      'padding-bottom': '{c_33}',
      show: true
    },
    'back-jds_action_button': {
      hidden: true,
      icon: 'ic_back',
      size: 'medium',
      kind: 'secondary'
    },
    'next-jds_action_button': {
      hidden: true,
      icon: 'ic_next',
      size: 'medium',
      kind: 'secondary'
    },
    jds_carousel_pagination: {
      hidden: false
    },
    'title-jds-text': {
      'font-family': '{text_152}',
      color: '{text_20}',
      'font-size': '{text_151}',
      'line-height': '{text_153}',
      'letter-spacing': '{text_154}',
      'font-weight': '{text_155}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}',
      value: 'Label',
      text: 'Label'
    },
    'subtitle-jds-text': {
      'font-family': '{text_147}',
      color: '{text_21}',
      'font-size': '{text_146}',
      'line-height': '{text_148}',
      'letter-spacing': '{text_149}',
      'font-weight': '{text_150}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}'
    }
  },
  variant: {
    density: {
      condensed: {
        container: {
          gap: '{c_34}'
        },
        'prefix-jds_action_button': {
          size: 'small'
        },
        'back-jds_action_button': {
          size: 'small'
        },
        'next-jds_action_button': {
          size: 'small'
        },
        jds_carousel_pagination: {
          density: 'condensed'
        }
      }
    },
    indicatorType: {
      label: {
        'left-container': {
          hidden: false
        },
        'prefix-container': {
          hidden: false
        },
        jds_carousel_pagination: {
          hidden: true
        }
      },
      dot_label: {
        'left-container': {
          hidden: false
        },
        'prefix-container': {
          hidden: false
        },
        jds_carousel_pagination: {
          hidden: false
        }
      },
      none: {
        'prefix-container': {
          hidden: true
        },
        jds_carousel_pagination: {
          hidden: true
        }
      }
    },
    autoPlay: {
      false: {
        'left-container': {
          hidden: false
        }
      },
      true: {
        'progress-container': {
          hidden: false
        }
      }
    },
    showArrows: {
      true: {
        'back-jds_action_button': {
          hidden: false
        },
        'next-jds_action_button': {
          hidden: false
        }
      }
    },
    playing: {
      true: {
        'prefix-jds_action_button': {
          icon: 'ic_pause'
        }
      }
    }
  },
  combination: [
    {
      true: {
        true: {
          'prefix-jds_action_button': {
            'z-index': 1,
            kind: 'tertiary'
          },
          jds_spinner: {
            hidden: false
          }
        }
      }
    },
    {
      true: {
        true: {
          'back-jds_action_button': {
            hidden: true
          }
        }
      }
    },
    {
      true: {
        false: {
          'progress-container': {
            hidden: true
          }
        }
      }
    }
  ],
  combination_config: [
    ['autoPlay', 'showDurationProgress'],
    ['showArrows', 'hideLeftArrow'],
    ['playing', 'showPlayPause']
  ],
  api: {
    config: {
      density: {
        type: 'JDSCarouselPaginationItem.density',
        values: ['relaxed', 'condensed']
      },
      indicatorType: {
        values: ['dot', 'label', 'dot_label', 'none']
      },
      showArrows: {
        values: [false, true]
      },
      hideLeftArrow: {
        values: [false, true],
        doc_description:
          'only used to hide the left arrow, no op when showArrows = false'
      },
      hideNextSlide: {
        values: [false, true],
        doc_description:
          'only used to hide the left arrow, no op when showArrows = false'
      },
      autoPlay: {
        values: [false, true],
        doc_description: 'hide autoplay button when autoPlay=false'
      },
      showPlayPause: {
        values: [true, false],
        doc_description: 'hide autoplay button when showPlayPause=false'
      },
      playing: {
        values: [false, true]
      },
      showDurationProgress: {
        values: [false, true]
      }
    },
    data: {
      jds_carousel_pagination: {
        selectedIndex: {
          type: 'number',
          name: 'selectedIndex'
        },
        count: {
          type: 'number',
          name: 'totalSlides',
          doc_description:
            'to be used when number of children != total slides (e.g. when lazyloading or server pagination)'
        },
        items: {
          type: 'list',
          name: '_paginationItems'
        }
      },
      jds_spinner: {
        value: {
          type: 'number',
          name: '_value'
        }
      },
      'title-jds-text': {
        value: {
          type: 'string',
          name: 'label',
          function: true
        }
      },
      'subtitle-jds-text': {
        value: {
          type: 'string',
          name: '_subtitle'
        }
      }
    },
    children: {
      'carousel-slot': {
        name: 'children',
        accepts: ['jds_carousel_slide']
      }
    },
    events: {
      'prefix-jds_action_button': {
        onClick: {
          name: 'onPlayPause',
          doc_description:
            'Triggered on resume/play/pause of auto playing slides.'
        }
      },
      'back-jds_action_button': {
        onClick: 'onBackBtn'
      },
      'next-jds_action_button': {
        onClick: 'onNextBtn'
      },
      jds_carousel_pagination: {
        onDotClick: {
          name: 'onDotClick',
          doc_description: 'Triggerred on click of pagination dot'
        }
      },
      'slider-container': {
        onClick: 'onClick',
        onSwipeLeft: 'onNext',
        onSwipeRight: 'onBack'
      },
      'carousel-slot': {
        onClick: 'onClick',
        onSwipeLeft: 'onNext',
        onSwipeRight: 'onBack'
      }
    },
    a11y: {
      'prefix-jds_action_button': {
        properties: {
          ariaLabel: {
            name: 'PlayPauseAriaLabel',
            value: 'Pause or Play Auto slide rotation'
          }
        }
      },
      'back-jds_action_button': {
        properties: {
          ariaLabel: {
            name: 'backButtonAriaLabel',
            value: 'Previous Slide'
          }
        }
      },
      'next-jds_action_button': {
        properties: {
          ariaLabel: {
            name: 'nextButtonAriaLabel',
            value: 'Next Slide'
          }
        }
      }
    }
  }
};
